// SAM-1275: the tenant's public web key (tenant.settings.public_api_key, served by /tenant-branding). The tenant
// Front Desk reads its business without `api_key` (crud hides it), and /business_access then takes this key together
// with the Front Desk's own JWT (the backend turns that pair into a staff context, SAM-845). The branding is loaded
// once per tab session; this keeps the key where the API clients (not React) can read it.
const STORAGE_KEY = 'tenantPublicApiKey';

export const rememberTenantPublicKey = (key: string | undefined | null): void => {
  if (!key) return;
  try { sessionStorage.setItem(STORAGE_KEY, key); } catch { /* storage unavailable: the client falls back */ }
};

export const readTenantPublicKey = (): string | undefined => {
  try { return sessionStorage.getItem(STORAGE_KEY) || undefined; } catch { return undefined; }
};
